import * as ServerOperations from "@/Common/Operations/operations.server";
import { Client } from "../Client";
import { GenericResponse } from "../Dto/GenericResponse";
import { GetFilteredLabAnalysisDefinitionsResponse } from "../Patient/Dto/GetFilteredLabAnalysisDefinitionsResponse";
import { ISaveManualResultsRequest } from "./Dtos/ISaveManualResultsRequest";

class ManualResultsApiClient {
    public static async saveManualResult(request: ISaveManualResultsRequest): Promise<GenericResponse> {
        return (await Client.postAsync<GenericResponse>(
            ServerOperations.Server.Myle_LabResults_SaveManualEntry,
            request
        )).data;
    }

    public static async fetchFilteredLabAnalysisDefinitions(searchText: string): Promise<GetFilteredLabAnalysisDefinitionsResponse> {
        return (await Client.postAsync<GetFilteredLabAnalysisDefinitionsResponse>(
            ServerOperations.Server.Myle_ManualLabResults_GetFilteredLabAnalysisDefinitions,
            { searchText }
        )).data;
    }
}

export { ManualResultsApiClient };
